import React from "react"
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { Row, Col, BreadcrumbItem } from "reactstrap"

const Breadcrumb = props => {
  return (
    <Row style={{ marginBottom: '0', marginTop: '0' }}>
      <Col xs={12} style={{ padding: '0', marginBottom: '0' }}>
        <div className="page-title-box d-sm-flex align-items-center justify-content-between" style={{ marginBottom: '0', paddingBottom: '0' }}>
          <h4 className="mb-sm-0 font-size-18" style={{ marginBottom: '0', lineHeight: '1.2', paddingBottom: '0' }}>{props.breadcrumbItem}</h4>
          <div className="page-title-right">
            <ol className="breadcrumb m-0" style={{ marginBottom: '0' }}>
              <BreadcrumbItem><Link to="#">{props.title}</Link></BreadcrumbItem>
              <BreadcrumbItem active>{props.breadcrumbItem}</BreadcrumbItem>
            </ol>
          </div>
        </div>
      </Col>
    </Row>
  )
}

Breadcrumb.propTypes = {
  breadcrumbItem: PropTypes.string,
  title: PropTypes.string
}

export default Breadcrumb
